import { classnames } from 'Utils/classnames/classnames.utils';
const DEFAULT = classnames(
  'prose-a:text-sienna prose-a:underline prose-a:transition-color prose-a:duration-250 prose-a:ease-in hocus:prose-a:text-sienna-active',
  'prose-li:list-disc',
  'text-black',
);
export const themes = {
  none: {
    thRoot: '',
  },
  'text-brand-n1': {
    thRoot: classnames(DEFAULT, 'space-y-15 font-brand text-24 leading-tight lg:text-32'),
  },
  'text-sans-n1': {
    thRoot: classnames(DEFAULT, 'space-y-10 font-sans text-14 leading-normal'),
  },
  'text-sans-n2': {
    thRoot: classnames(DEFAULT, 'space-y-10 font-sans text-12 leading-normal'),
  },
  'text-sans-n3': {
    thRoot: classnames(DEFAULT, 'space-y-10 font-sans text-16 leading-normal'),
  },
};
